import { render } from "./_form-phone.vue?vue&type=template&id=21a6b03e"
import script from "./_form-phone.vue?vue&type=script&lang=js"
export * from "./_form-phone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__